import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  TributacaoCfopCadastroDto,
  TributacaoCfopCadastroImpostoDto,
  TributacaoCfopCadastroSchema,
} from "./TributacaoCfopCadastro.Dto";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  MapearErrosServidor,
  MapearErrosServidorCampo,
} from "src/hook/Functions";
import {
  TributacaoCfopAtualizar,
  TributacaoCfopBuscarId,
  TributacaoCfopIncluir,
} from "src/services/Fiscal.Service";
import { IRoute } from "src/interfaces/IRoute";
import { ConsultarCategoria } from "src/hook/Consulta/ConsultaCategoria.Module";
import { CategoriaBuscarPorId } from "src/services/Estoque.Service";
import { showToast } from "src/componentes";

const TributacaoCfopCadastroCode = () => {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [incluir, setIncluir] = useState(false);
  const navigate = useNavigate();
  const id = searchParams.get("id");
  const tributacaoid = searchParams.get("tributacaoid");
  const [data, setData] = useState<
    TributacaoCfopCadastroImpostoDto[] | undefined
  >([]);
  const [menuItens, setMenuItens] = useState<IRoute[]>([]);
  const [selectedParametroValor, setSelectedParametroValor] =
    useState<string>("");

  const form = useForm<TributacaoCfopCadastroDto>({
    resolver: yupResolver(TributacaoCfopCadastroSchema),
    defaultValues: { parametroValor: 0 },
  });

  const consultarCategoria = ConsultarCategoria();

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      try {
        if (id) {
          setLoading(true);
          const response = await TributacaoCfopBuscarId(id);
          if (response.data.success) {
            const data = response.data.data;
            setSelectedParametroValor(data.tipoParametro.toString());

            if (data.tipoParametro === 1) {
              const categoriaresponse = await CategoriaBuscarPorId(
                data.parametroValor.toString()
              );
              if (categoriaresponse.data.success) {
                const categoriaData = categoriaresponse.data.data;
                data.categoriaNome = categoriaData.nome;
              } else {
                showToast({
                  message: "Ocorreu erro ao carregar Categoria",
                  title: "Erro",
                  variant: "Danger",
                });
              }
            }

            form.reset(data);

            setIncluir(false);
            setData(data.impostos);
            setMenuItens([
              {
                name: "Novo ICMS...",
                route: `/fiscal/tributacao/cfop/imposto/cadastro?type=0&tributacaocfopid=${id}`,
              },
              {
                name: "Novo IPI...",
                route: `/fiscal/tributacao/cfop/imposto/cadastro?type=1&tributacaocfopid=${id}`,
              },
              {
                name: "Novo PIS...",
                route: `/fiscal/tributacao/cfop/imposto/cadastro?type=2&tributacaocfopid=${id}`,
              },
              {
                name: "Novo COFINS...",
                route: `/fiscal/tributacao/cfop/imposto/cadastro?type=3&tributacaocfopid=${id}`,
              },
            ]);
          } else {
            showToast({
              message: "Ocorreu erro ao carregar TributacaoCfop",
              title: "Erro",
              variant: "Danger",
            });
          }
        } else {
          setIncluir(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [id]);

  const onSubmit = async (data: TributacaoCfopCadastroDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    data.tributacaoId = Number(tributacaoid);
    data.tipoParametro = data.tipoParametro = Number(data.tipoParametro);
    data.parametroValor = Number(data.parametroValor);

    if (incluir === true) {
      TributacaoCfopIncluir(data)
        .then((response) => {
          if (response.data.success) {
            navigate(`/fiscal/tributacao/cadastro?id=${tributacaoid}`);
          } else {
            MapearErrosServidorCampo(
              response.data.notifications,
              form.setError
            );
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      data.id = Number(id);
      data.tributacaoId = Number(tributacaoid);
      data.tipoParametro = data.tipoParametro = Number(data.tipoParametro);
      data.parametroValor = Number(data.parametroValor);

      TributacaoCfopAtualizar(data)
        .then((response) => {
          if (response.data.success) {
            navigate(`/fiscal/tributacao/cadastro?id=${tributacaoid}`);
          } else {
            MapearErrosServidorCampo(
              response.data.notifications,
              form.setError
            );
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const getOptions = () => {
    return [
      { value: "", label: "Selecione" },
      { value: "0", label: "Todos" },
      { value: "1", label: "Categoria Id" },
    ];
  };

  return {
    loading,
    onSubmit,
    form,
    incluir,
    data,
    menuItens,
    setSelectedParametroValor,
    selectedParametroValor,
    getOptions,
    consultarCategoria,
  };
};
export default TributacaoCfopCadastroCode;
